import React, { useEffect, useState } from "react";
import close from "../../../assets/svg/close.svg";
import DOMPurify from 'dompurify';
import { createVehicleTypeApi, getVehicleTypeApi, updateVehicleTypApi } from "../master-api";
import { Container, Row, Col } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import { getDeptApi, getLocationApi, getProductTypeApi } from "../customers/customer-api";
import plus from "../../../assets/svg/plus.svg";
import "./vehiclelist.css";
import closeIcon from "../../../assets/svg/close-red.svg";

function VehicleAdd({ typeId, onSuccess, onClose }) {
  /*  useEffect(() => {
     if (show) {
       document.body.classList.add("modal-open");
     } else {
       document.body.classList.remove("modal-open");
     }
     return () => document.body.classList.remove("modal-open");
   }, [show]);
 
   if (!show) return null; */
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedDept, setSelectedDept] = useState([]);
  const [productTypeList, setProductTypeList] = useState([{id:'', product_types:[],  load_in: "", load_out: "", lag: "",}]);
const [productTypeRemovedId, setProductTypeRemovedId] = useState([]);

  const handleLocationChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedLocation(selectedOptions);
  };
  const handleDeptChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedDept(selectedOptions);
  };
  const getLocationData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getLocationApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };
  const getDepartmentData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getDeptApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };
  const handleProductTypeChange = (index,selectedOptions) => {
    console.log(selectedOptions);
     const tempList=[...productTypeList];
    tempList[index].product_types=selectedOptions;
    setProductTypeList(tempList);
  };

  const [cachedOptions, setCachedOptions] = React.useState([]);
    const getProductTypeData = async (inputValue) => {
    /* setTimeout(async () => { */
     

  const productValuesString = productTypeList
  .filter(item => item.product_types.length > 0)
  .flatMap(item => item.product_types.map(product => product.value))
  .join(',');
      const response = await getProductTypeApi(productValuesString,inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          return response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
         // callback(options);
        }
      }
   /*  }, 1000); */
  };
  const handleMenuOpen = () => {
    // Preload options when dropdown is clicked open with empty input
    getProductTypeData('').then((options) => setCachedOptions(options));
  };

  const apiUrl = process.env.REACT_APP_API_URL;
  const [typeCode, setTypeCode] = useState("");
  const [typeName, setTypeName] = useState("");
  const [dimension, setDimension] = useState("");
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [loadInDuration, setLoadInDuration] = useState("");
  const [loadOutDuration, setLoadOutDuration] = useState("");
  const [lagDuration, setLagDuration] = useState("");
  const [lastKey, setLastKey] = useState("");

  useEffect(() => {
    if (typeId != null && typeId !== "") {
      getVehicleType()
    }
  }, []);

  const getVehicleType = async () => {
    try {
      //'sortBy=$sortbyorder&sortByField=$sortbyfiledname&location_id=${filterby[0]['Locationid']}&dock_id=${filterby[0]['dockid']}&dock_type=${filterby[0]['docktypeid']}&vehicletype_id=${filterby[0]['vehicletypeid']}&from_dock_in=${filterby[0]['from_dock_in']}&to_dock_in=${filterby[0]['to_dock_in']}&from_dock_out=${filterby[0]['from_dock_out']}&to_dock_out=&status=${filterby[0]['to_dock_out']}&search=&limit=$itemperpagecount&skip=${currentPages * itemperpagecount}'
      const response = await getVehicleTypeApi(typeId);
      if (response.data.success === true) {
        const vehicleTypeData = response.data.vehicle_type;
        setTypeCode(vehicleTypeData.code)
        setTypeName(vehicleTypeData.name)
        setDimension(vehicleTypeData.dimension)
        setLength(vehicleTypeData.length)
        setWidth(vehicleTypeData.width)
        setHeight(vehicleTypeData.height)
        setLoadInDuration(vehicleTypeData.load_in_time)
        setLoadOutDuration(vehicleTypeData.load_out_time)
        setLagDuration(vehicleTypeData.lag_duration)
        setSelectedLocation(vehicleTypeData.locations ?? [])
        setSelectedDept(vehicleTypeData.departments ?? [])
        setProductTypeList(vehicleTypeData.durations ?? [])
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const [validations, setValidations] = useState({
    "code": "",
    "name": "",
    "dimension": "",
    "length": "",
    "width": "",
    "height": "",
    "load_in_time": "",
    "load_out_time": "",
    "lag_duration": "",
    "locations": "",
    "departments": "",
  });

  const submitVehicleType = async () => {
    const dataBeforeSanitize = {
      "id": typeId,
      "code": typeCode,
      "name": typeName,
      "dimension": dimension,
      "length": length,
      "width": width,
      "height": height,
      "load_in_time": loadInDuration,
      "load_out_time": loadOutDuration,
      "lag_duration": lagDuration,
      "locations": selectedLocation.map(item => item.value),
      "departments": selectedDept.map(item => item.value),
      "removed_durations":productTypeRemovedId,
      "durations":productTypeList
  .filter((item) => item.product_types.length > 0)
  .map((item) => ({
     id: item.id,
    load_in: item.load_in,
    load_out: item.load_out,
    lag: item.lag,
    product_type_id: item.product_types.map((product) => product.value),
  }))
    };
    const dataAfterSanitize = {};
    Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
      if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === 'assignee') {
        dataAfterSanitize[key] = value;
      } else {
        dataAfterSanitize[key] = DOMPurify.sanitize(value);
      }
    });
    if (typeId == null && typeId !== "") {
      const response = await createVehicleTypeApi(dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.success === true) {
          onSuccess(response.data)

        }
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {

          const validationTemp = {
            "code": "",
            "name": "",
            "dimension": "",
            "length": "",
            "width": "",
            "height": "",
            "load_in_time": "",
            "load_out_time": "",
            "lag_duration": "", "locations": "",
            "departments": "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? '' : value[0];
          });
          console.log('validationTemp...', validationTemp);
          setValidations(validationTemp);
        });
      }
    } else {
      const response = await updateVehicleTypApi(typeId, dataAfterSanitize);
      if (response.status === 200) {
        if (response.data.success === true) {
          onSuccess(response.data)

        }
      }
      if (response.status === 400) {
        new Promise((resolve, reject) => {

          const validationTemp = {
            "code": "",
            "name": "",
            "dimension": "",
            "length": "",
            "width": "",
            "height": "",
            "load_in_time": "",
            "load_out_time": "",
            "lag_duration": "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? '' : value[0];
          });
          console.log('validationTemp...', validationTemp);
          setValidations(validationTemp);
        });
      }
    }
  };
  const multiselectCustomStyles = {
    control: (provided) => ({ ...provided, backgroundColor: "#ffffff", borderRadius: "8px", border: "0.7px solid #E5E5E5", padding: "2px", fontWeight: "500", fontSize: "13px", color: "#212129" }),
    option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff", color: state.isSelected ? "#fff" : "#333", padding: 10 }),
    multiValue: (provided) => ({ ...provided, backgroundColor: "#F6F7F8", color: "#212129", borderRadius: "5px", padding: "2px 5px" }),
    multiValueLabel: (provided) => ({ ...provided, color: "#212129" }),
    multiValueRemove: (provided) => ({ ...provided, color: "#212129", cursor: "pointer", ":hover": { backgroundColor: "red", color: "white" } }),
  };
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      borderRadius: "16px",
      padding: "24px",
      backgroundColor: "#fff",
      width: "100%",
      maxWidth: "900px",
      height: '470px',
      overflowY: "auto",
    },
  };
  return (
    <div
      style={modalStyle.overlay}
    >
      <div
        style={modalStyle.modal}
      >
        <div >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <h5
              style={{
                fontFamily: "Epilogue",
                fontWeight: 700,
                fontSize: "20px",
                margin: 0,
              }}
            >
              Add vehicle type
            </h5>
            <button
              type="button"
              onClick={onClose}
              style={{
                background: "none",
                border: "1px solid #D4DDE7",
                borderRadius: "100px",
                padding: "8px",
                height: "40px",
                width: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <img
                src={close}
                alt="Close"
                style={{ width: "14px", height: "14px" }}
              />
            </button>
          </div>

          {/* Body */}
          <form>
            <Row className="px-0 mx-0">
              <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Code<span style={{ color: '#FF4444' }}>*</span> </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={typeCode}
                  onChange={(event) => {
                    setTypeCode(event.target.value); // Update state with input value
                  }}
                />
                <span className="field-error" >{validations.code}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Name<span style={{ color: '#FF4444' }}>*</span> </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={typeName}
                  onChange={(event) => {
                    setTypeName(event.target.value); // Update state with input value
                  }}
                />
                <span className="field-error" >{validations.name}</span>
              </Col>
              <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
                <div className="field-title">
                  Location
                  {/* <span style={{ color: "#FF4444" }}>*</span> */}
                </div>
                <AsyncSelect isMulti cacheOptions value={selectedLocation} loadOptions={getLocationData} onChange={handleLocationChange} defaultOptions placeholder="Select locations" styles={multiselectCustomStyles} isClearable={false} />
                <span className="field-error">{validations.locations}</span>
              </Col>

              <Col xs={12} sm={12} md={6} className="mt-3 px-0 ps-md-1">
                <div className="field-title">
                  Department
                  {/* <span style={{ color: "#FF4444" }}>*</span> */}
                </div>
                <AsyncSelect isMulti cacheOptions value={selectedDept} loadOptions={getDepartmentData} onChange={handleDeptChange} defaultOptions placeholder="Select departments" styles={multiselectCustomStyles} isClearable={false} />
                <span className="field-error">{validations.departments}</span>
              </Col>

              <Col xs={12} sm={12} className="mt-3">
                {/* Dimension Label with Divider and Unit */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "12px",
                    width: "100%",
                  }}
                >
                  <label
                    style={{
                      fontFamily: "Epilogue",
                      fontWeight: 600,
                      fontSize: "16px",
                      color: "#172B4D",
                      whiteSpace: "nowrap",
                      marginRight: "10px",
                    }}
                  >
                    Dimension
                  </label>
                  <div
                    style={{
                      flex: 1,
                      borderBottom: "2px dashed #E5E5E5",
                      margin: "0 -10px",
                    }}
                  ></div>
                  <select
                    style={{
                      width: "90px",
                      height: "28px",
                      backgroundColor: "#fceaea",
                      border: "none",
                      borderRadius: "16px",
                      fontSize: "13px",
                      fontWeight: "500",
                      padding: "0 10px",
                      color: "#333",
                      marginLeft: "12px",
                    }}
                    value={dimension}
                    onChange={(event) => {
                      setDimension(event.target.value); // Update state with input value
                    }}
                  >
                    <option value="meter" selected>Meters</option>
                    <option value="cm">CM</option>
                    <option value="lg">LG</option>
                  </select>
                </div>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Length </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={length}
                  onChange={(event) => {
                    setLength(event.target.value); // Update state with input value
                  }}
                />
                <span className="field-error" >{validations.length}</span>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Breadth </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={width}
                  onChange={(event) => {
                    setWidth(event.target.value); // Update state with input value
                  }}
                />
                <span className="field-error" >{validations.width}</span>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Height </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={height}
                  onChange={(event) => {
                    setHeight(event.target.value); // Update state with input value
                  }}
                />
                <span className="field-error" >{validations.height}</span>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Load In (hrs)<span style={{ color: '#FF4444' }}>*</span> </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={loadInDuration}
                  onKeyDown={(event) => { setLastKey(event.key); }}
                  onChange={(event) => {
                    const inputText = event.target.value;
                    if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                      console.log(event.key)
                      if (lastKey === "Backspace") {
                        setLoadInDuration(inputText);
                      } else {
                        setLoadInDuration(inputText.length === 2 ? inputText + ':' : inputText);
                      }
                    }
                  }}
                />
                <span className="field-error" >{validations.load_in_time}</span>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Load Out (hrs)<span style={{ color: '#FF4444' }}>*</span> </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={loadOutDuration}
                  onKeyDown={(event) => { setLastKey(event.key); }}
                  onChange={(event) => {
                    const inputText = event.target.value;
                    if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                      console.log(event.key)
                      if (lastKey === "Backspace") {
                        setLoadOutDuration(inputText);
                      } else {
                        setLoadOutDuration(inputText.length === 2 ? inputText + ':' : inputText);
                      }
                    }
                  }}
                />
                <span className="field-error" >{validations.load_out_time}</span>
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-3 px-0 ps-md-1">
                <div className="field-title mb-1"> Lag Duration</div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={lagDuration}
                  onKeyDown={(event) => { setLastKey(event.key); }}
                  onChange={(event) => {
                    const inputText = event.target.value;
                    if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                      console.log(event.key)
                      if (lastKey === "Backspace") {
                        setLagDuration(inputText);
                      } else {
                        setLagDuration(inputText.length === 2 ? inputText + ':' : inputText);
                      }
                    }
                  }}
                />
                <span className="field-error" >{validations.lag_duration}</span>
              </Col>

            </Row>
            <div className="mt-4 px-1" style={{background:'#F8F8F8', padding:'8px', borderRadius:'8px'}}>
              {productTypeList.map((item,index) => (
  <div style={{width:'100%'}}>
    <Row className="px-0" style={{width:'100%',}}>
       <Col xs={12} sm={12} md={4} className="mt-1 px-0 ps-md-1" >
       <div className="ps-1">
                <div className="field-title mb-1">
                  Product Type
                  {/* <span style={{ color: "#FF4444" }}>*</span> */}
                </div>
                <AsyncSelect isMulti  value={item.product_types} loadOptions={getProductTypeData} defaultOptions={cachedOptions}  onMenuOpen={handleMenuOpen} onChange={(selectedOptions)=>{handleProductTypeChange(index,selectedOptions)}}  placeholder="Select product type" styles={multiselectCustomStyles} isClearable={false} />
               {/*  <span className="field-error">{validations.product_types}</span> */}
                </div>
              </Col>

               <Col xs={12} sm={12} md={8}>
               <Row style={{width:'100%'}}>               
     <Col xs={12} sm={12} md={4} className="mt-1 px-0 ps-md-1">
                <div className="field-title mb-1"> Load In (hrs)<span style={{ color: '#FF4444' }}>*</span> </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={item.load_in}
                  onKeyDown={(event) => { setLastKey(event.key); }}
                  onChange={(event) => {
                    const inputText = event.target.value;
                    if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                     const tempList=[...productTypeList];
                      if (lastKey === "Backspace") {
                        //setLoadInDuration(inputText);
                        tempList[index].load_in=inputText;
                      } else {
                         tempList[index].load_in=inputText.length === 2 ? inputText + ':' : inputText;
                        //setLoadInDuration(inputText.length === 2 ? inputText + ':' : inputText);
                      }
                    setProductTypeList(tempList);
                    }
                  }}
                />
               {/*  <span className="field-error" >{validations.load_in_time}</span> */}
              </Col>
              <Col xs={12} sm={12} md={4} className="mt-1 px-0 ps-md-1">
                <div className="field-title mb-1"> Load Out (hrs)<span style={{ color: '#FF4444' }}>*</span> </div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={item.load_out}
                  onKeyDown={(event) => { setLastKey(event.key); }}
                  onChange={(event) => {
                    const inputText = event.target.value;
                    if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                     const tempList=[...productTypeList];
                      if (lastKey === "Backspace") {
                       // setLoadOutDuration(inputText);
                        tempList[index].load_out=inputText;
                      } else {
                        //setLoadOutDuration(inputText.length === 2 ? inputText + ':' : inputText);
                        tempList[index].load_out=inputText.length === 2 ? inputText + ':' : inputText;
                      }
                       setProductTypeList(tempList);
                    }
                  }}
                />
              {/*   <span className="field-error" >{validations.load_out_time}</span> */}
              </Col>
              <Col xs={12} sm={12} md={3} className="mt-1 px-0 ps-md-1">
                <div className="field-title mb-1"> Lag Duration</div>
                <input
                  type="text"
                  placeholder="Enter here"
                  className="input-field mt-1 w-100"
                  value={item.lag}
                  onKeyDown={(event) => { setLastKey(event.key); }}
                  onChange={(event) => {
                    const inputText = event.target.value;
                    if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                      const tempList=[...productTypeList];
                      if (lastKey === "Backspace") {
                        //setLagDuration(inputText);
                         tempList[index].lag=inputText;
                      } else {
                        //setLagDuration(inputText.length === 2 ? inputText + ':' : inputText);
                         tempList[index].lag=inputText.length === 2 ? inputText + ':' : inputText;
                      }
                       setProductTypeList(tempList);
                    }
                  }}
                />
               {/*  <span className="field-error" >{validations.lag_duration}</span> */}
              </Col>
              <Col className="px-0" xs={12} sm={12} md={1} style={{ display:'flex', alignItems:'end',justifyContent:'end',  }}>
              <div onClick={()=>{
                if(item.id!==null && item.id!==""){
                setProductTypeRemovedId(productTypeRemovedId => [...productTypeRemovedId,item.id]);
                }
                 const tempList=[...productTypeList];
                tempList.splice(index,1);
                 setProductTypeList(tempList);
              }} className="style-justify-center" style={{width:'40px', height:'40px', borderRadius:'50px', border:'1px solid #EBEBEB',}}>
                  <img src={closeIcon} alt="add" className="btn-icon w-2 h-2" />         
              </div>
              </Col>
              </Row>
              </Col>
              </Row>
               
  </div>
))}

                             <button className="mt-1"
              onClick={()=>{
    const tempList=[...productTypeList];
    tempList.push({id:'', product_types:[],  load_in: "", load_out: "", lag: "",})
    setProductTypeList(tempList);
   }} 
              type="button"
              style={{
                backgroundColor: "#D35258",
                color: "#fff",
                borderRadius: "12px",
                padding: "8px 16px",
                fontWeight: "600",
                fontFamily: "Epilogue",
                fontSize: "14px",
                cursor: "pointer",
                border: "none",
                display:'flex',
                alignItems:'center',
                justifyContent:'center'
              }}
            >
              <span className="icon pe-1">
                                <img src={plus} alt="add" className="btn-icon w-2 h-2" />
                              </span>
              Add
            </button>     
            </div> 
           

          </form>

          {/* Footer Buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "24px",
              gap: "8px",
            }}
          >
            <button
              type="button"
              onClick={onClose}
              style={{
                backgroundColor: "#fff",
                color: "#333",
                borderRadius: "12px",
                padding: "8px 24px",
                fontWeight: "600",
                border: "1px solid #ddd",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              onClick={submitVehicleType}
              type="button"
              style={{
                backgroundColor: "#D35258",
                color: "#fff",
                borderRadius: "12px",
                padding: "8px 24px",
                fontWeight: "600",
                fontFamily: "Epilogue",
                fontSize: "14px",
                cursor: "pointer",
                border: "none",
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VehicleAdd;
